import script from "./ImagesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__